const SelectQuestionBoxLabel = ({event, onChange}) => {

    return (
        <div className="survey-form">
            <label className="field-label">Titre de la boite à question</label>
            <input
            type="text"
            className="input-field"
            placeholder="Saisir le titre de la boite à question..."
            value={event.title ?? ''}
            onChange={(e) => onChange('title', e.target.value)}
            />
        </div>
        );

}

export default SelectQuestionBoxLabel